import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCancelEventRequest = {};
var _bulkCancelEventResponse = { results: '_bulkEventResult' };
var _bulkCreateEventRequest = { events: '_maskedEvent' };
var _bulkCreateEventResponse = { results: '_bulkEventResult' };
var _bulkEventResult = { item: '_event' };
var _bulkUpdateEventRequest = {
    events: '_bulkUpdateEventRequestMaskedEvent',
};
var _bulkUpdateEventRequestMaskedEvent = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _bulkUpdateEventResponse = { results: '_bulkEventResult' };
var _cancelEventRequest = {};
var _cancelEventResponse = { event: '_event' };
var _createEventRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _createEventResponse = { event: '_event' };
var _event = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    start: '_zonedDate',
    end: '_zonedDate',
    adjustedStart: '_zonedDate',
    adjustedEnd: '_zonedDate',
    recurrenceRule: '_recurrenceRule',
};
var _getEventRequest = {};
var _getEventResponse = { event: '_event' };
var _listEventsByContactIdRequest = {};
var _listEventsByContactIdResponse = { events: '_event' };
var _listEventsByMemberIdRequest = {};
var _listEventsByMemberIdResponse = { events: '_event' };
var _listEventsRequest = {};
var _listEventsResponse = { events: '_event' };
var _maskedEvent = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _queryEventsRequest = {};
var _queryEventsResponse = { events: '_event' };
var _recurrenceRule = { until: '_zonedDate', adjustedUntil: '_zonedDate' };
var _restoreEventDefaultsRequest = {};
var _restoreEventDefaultsResponse = { event: '_event' };
var _splitRecurringEventRequest = {};
var _splitRecurringEventResponse = {
    updatedRecurringEventEndingBeforeSplit: '_event',
    newRecurringEventStartingFromSplit: '_event',
};
var _updateEventRequest = {
    fieldmask: 'google.protobuf.FieldMask',
    event: '_event',
};
var _updateEventResponse = { event: '_event' };
var _zonedDate = { utcDate: 'google.protobuf.Timestamp' };
function resolveWixCalendarParticipanteventsV3ParticipantEventsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/participant-events-3',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
            {
                srcPath: '/_api/calendar/v3/events/contactId',
                destPath: '/v3/events/contactId',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/events/contactId',
                destPath: '/v3/events/contactId',
            },
            {
                srcPath: '/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/events/memberId',
                destPath: '/v3/events/memberId',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixCalendarEventsV3EventsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/events-3',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/_api/calendar/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
            {
                srcPath: '/_api/calendar/v3/ro/events',
                destPath: '/v3/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/calendar/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/events',
                destPath: '/v3/events',
            },
            {
                srcPath: '/_api/calendar/v3/bulk/events',
                destPath: '/v3/bulk/events',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/events',
                destPath: '/v3/events',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves an event. */
export function getEvent(payload) {
    var _a = serializer(_getEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __getEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.events.v3.EventsService.GetEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEvent.fromReq = fromReq;
    __getEvent.__isAmbassador = true;
    return __getEvent;
}
/** Retrieves a list of events by their IDs. */
export function listEvents(payload) {
    var _a = serializer(_listEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.events.v3.EventsService.ListEvents',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEvents.fromReq = fromReq;
    __listEvents.__isAmbassador = true;
    return __listEvents;
}
/**
 * Retrieves a list of events, given the provided paging, filtering, and sorting.
 *
 *
 * Query Events runs with these defaults, which you can override:
 * - sorted by `start` in `ASC` order
 * - `cursorPaging.limit` is `50`
 *
 * You can't filter by event ID. To query by event ID, use
 * [Get Event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/get-event)
 * or [List Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events).
 *
 * You can't filter by contact or member ID. To query by a participant's contact
 * or member ID, use
 * [List Events by Contact ID](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events-by-contact-id)
 * or [List Events by Member ID](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events-by-member-id).
 *
 * For field support for filters and sorting,
 * see [Calendar Events V3: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
 */
export function queryEvents(payload) {
    var _a = serializer(_queryEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryEventsResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __queryEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.QueryEvents',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryEvents.fromReq = fromReq;
    __queryEvents.__isAmbassador = true;
    return __queryEvents;
}
/**
 * Creates an event.
 *
 *
 * If you provide `recurrenceRule`, an event with `{"recurrenceType": "MASTER"}` is
 * created. Then, you can't set `start.localDate` to a past date, though the time can be
 * earlier on the same day. You can, however, create single-occurrence events for
 * past dates.
 *
 * You can't create an event with `recurrenceType` set to `INSTANCE` or `EXCEPTION`.
 * `INSTANCE` events are generated automatically based on the recurrence rule in the
 * relevant `MASTER` event. `EXCEPTION` events are automatically created when you
 * [update](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
 * an `INSTANCE` event, which changes its `recurrenceType` to `EXCEPTION`.
 */
export function createEvent(payload) {
    var _a = serializer(_createEventRequest, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __createEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.CreateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createEvent.fromReq = fromReq;
    __createEvent.__isAmbassador = true;
    return __createEvent;
}
/**
 * Creates multiple events in bulk.
 *
 *
 * If you provide `recurrenceRule`, an event with `{"recurrenceType": "MASTER"}` is
 * created. Then, you can't set `start.localDate` to a past date, though the time can be
 * earlier on the same day. You can, however, create single-occurrence events for
 * past dates.
 *
 * You can't create an event with `recurrenceType` set to `INSTANCE` or `EXCEPTION`.
 * `INSTANCE` events are generated automatically based on the recurrence rule in the
 * relevant `MASTER` event. `EXCEPTION` events are automatically created when you
 * [update](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
 * an `INSTANCE` event, which changes its `recurrenceType` to `EXCEPTION`.
 */
export function bulkCreateEvent(payload) {
    var _a = serializer(_bulkCreateEventRequest, { _event: _event, _maskedEvent: _maskedEvent, _recurrenceRule: _recurrenceRule, _zonedDate: _zonedDate }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateEventResponse, {
        _bulkEventResult: _bulkEventResult,
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __bulkCreateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.BulkCreateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/bulk/events/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateEvent.fromReq = fromReq;
    __bulkCreateEvent.__isAmbassador = true;
    return __bulkCreateEvent;
}
/**
 * Updates an event.
 *
 *
 * When updating an event with `{"recurrenceType": "INSTANCE"}`, the
 * `recurrenceType` automatically changes to `EXCEPTION`.
 *
 * When updating an event with `{"recurrenceType": "MASTER"}`:
 * + Past `INSTANCE` and `EXCEPTION` events remain unchanged.
 * + For future `INSTANCE` events, all relevant fields are updated.
 * + For future `EXCEPTION` events, only changes to the `inheritedFields` are
 * applied, while other fields remain unchanged.
 */
export function updateEvent(payload) {
    var _a = serializer(_updateEventRequest, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __updateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'PATCH',
            methodFqn: 'wix.calendar.events.v3.EventsService.UpdateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{event.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateEvent.fromReq = fromReq;
    __updateEvent.__isAmbassador = true;
    return __updateEvent;
}
/**
 * Updates multiple events in bulk.
 *
 *
 * When updating an event with `{"recurrenceType": "INSTANCE"}`, the
 * `recurrenceType` automatically changes to `EXCEPTION`.
 *
 * When updating an event with `{"recurrenceType": "MASTER"}`:
 * + Past `INSTANCE` and `EXCEPTION` events remain unchanged.
 * + For future `INSTANCE` events, all relevant fields are updated.
 * + For future `EXCEPTION` events, only changes to the `inheritedFields` are
 * applied, while other fields remain unchanged.
 */
export function bulkUpdateEvent(payload) {
    var _a = serializer(_bulkUpdateEventRequest, { _bulkUpdateEventRequestMaskedEvent: _bulkUpdateEventRequestMaskedEvent, _event: _event, _recurrenceRule: _recurrenceRule, _zonedDate: _zonedDate }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateEventResponse, {
        _bulkEventResult: _bulkEventResult,
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __bulkUpdateEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.BulkUpdateEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/bulk/events/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateEvent.fromReq = fromReq;
    __bulkUpdateEvent.__isAmbassador = true;
    return __bulkUpdateEvent;
}
/**
 * Restores the event's default values from the relevant schedule or `MASTER`
 * event.
 *
 *
 * You must provide `fields` to specify which `inheritedFields` are restored.
 *
 * For example, if you've created an event that takes place in a non-default
 * location with a custom title and capacity, but you want to reset only title
 * and capacity to default values without affecting the location, provide the
 * event ID and set `fields` to `["TITLE", "CAPACITY"]`.
 *
 * Refer to the [default values article](https://dev.wix.com/docs/rest/business-management/calendar/default-values)
 * for more information.
 */
export function restoreEventDefaults(payload) {
    var _a = serializer(_restoreEventDefaultsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreEventDefaultsResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __restoreEventDefaults(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.RestoreEventDefaults',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{eventId}/restore-defaults',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreEventDefaults.fromReq = fromReq;
    __restoreEventDefaults.__isAmbassador = true;
    return __restoreEventDefaults;
}
/**
 * Splits a recurring `MASTER` event into 2 separate `MASTER` events.
 *
 *
 * You must provide a `splitLocalDate` that's in the future and after the `start`
 * date of the next `INSTANCE` or `EXCEPTION` event in the series. Additionally,
 * there must be another `INSTANCE` or `EXCEPTION` event following this next event,
 * as the changes wouldn't affect any event without a subsequent occurrence.
 *
 * If you want to modify a `MASTER` event with the changes already applying to
 * the very next event, use
 * [Update Event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
 * instead, as this preserves past events and only modifies future events.
 *
 * The main consequences are:
 * - **The original `MASTER` event is shortened**. Its `recurrenceRule.until.localDate`
 * is updated to `end.localDate` of the latest `INSTANCE` or `EXCEPTION`
 * event starting before `splitLocalDate`. If an `INSTANCE` or `EXCEPTION` event
 * starts before but ends after `splitLocalDate`, `until.localDate` is set
 * to value that's later than `splitLocalDate`.
 * - **A new `MASTER` event is created**, starting from the first event that
 * begins after `splitLocalDate`.
 * - **Existing `INSTANCE` and `EXCEPTION` events that occur after the split are updated**.
 * Their `recurringEventId` is set to the ID of the newly created `MASTER` event.
 */
export function splitRecurringEvent(payload) {
    var _a = serializer(_splitRecurringEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_splitRecurringEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __splitRecurringEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.SplitRecurringEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{recurringEventId}/split',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __splitRecurringEvent.fromReq = fromReq;
    __splitRecurringEvent.__isAmbassador = true;
    return __splitRecurringEvent;
}
/** Cancels an event. */
export function cancelEvent(payload) {
    var _a = serializer(_cancelEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelEventResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __cancelEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.CancelEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/events/{eventId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelEvent.fromReq = fromReq;
    __cancelEvent.__isAmbassador = true;
    return __cancelEvent;
}
/** Cancels multiple events in bulk. */
export function bulkCancelEvent(payload) {
    var _a = serializer(_bulkCancelEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCancelEventResponse, {
        _bulkEventResult: _bulkEventResult,
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __bulkCancelEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'POST',
            methodFqn: 'wix.calendar.events.v3.EventsService.BulkCancelEvent',
            url: resolveWixCalendarEventsV3EventsServiceUrl({
                protoPath: '/v3/bulk/events/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCancelEvent.fromReq = fromReq;
    __bulkCancelEvent.__isAmbassador = true;
    return __bulkCancelEvent;
}
/**
 * Retrieves a list of events filtered by the participant's
 * [contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/introduction)
 * ID.
 *
 *
 * You can't set `toLocalDate` to a value that's more than a full year after
 * `fromLocalDate`.
 */
export function listEventsByContactId(payload) {
    var _a = serializer(_listEventsByContactIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsByContactIdResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listEventsByContactId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.participantevents.v3.ParticipantEventsService.ListEventsByContactId',
            url: resolveWixCalendarParticipanteventsV3ParticipantEventsServiceUrl({
                protoPath: '/v3/events/contactId/{contactId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventsByContactId.fromReq = fromReq;
    __listEventsByContactId.__isAmbassador = true;
    return __listEventsByContactId;
}
/**
 * Retrieves a list of events filtered by the participant's
 * [member](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/introduction)
 * ID.
 *
 *
 * You can't set `toLocalDate` to a value that's more than a full year after
 * `fromLocalDate`.
 */
export function listEventsByMemberId(payload) {
    var _a = serializer(_listEventsByMemberIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventsByMemberIdResponse, {
        _event: _event,
        _recurrenceRule: _recurrenceRule,
        _zonedDate: _zonedDate,
    }).fromJSON;
    function __listEventsByMemberId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.event',
            method: 'GET',
            methodFqn: 'wix.calendar.participantevents.v3.ParticipantEventsService.ListEventsByMemberId',
            url: resolveWixCalendarParticipanteventsV3ParticipantEventsServiceUrl({
                protoPath: '/v3/events/memberId/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventsByMemberId.fromReq = fromReq;
    __listEventsByMemberId.__isAmbassador = true;
    return __listEventsByMemberId;
}
//# sourceMappingURL=http.impl.js.map